export default "__VITE_ASSET__BCkZX_FE__"